/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjggMTRIMjFWMjcuOTk5OEgyOFYxNFoiLz48cGF0aCBkPSJNNyA5LjMzMjAzSDBWMjcuOTk4NEg3VjkuMzMyMDNaIi8+PHBhdGggZD0iTTE3LjUgMEgxMC41VjI3Ljk5OTZIMTcuNVYwWiIvPjwvc3ZnPg==";